import { create } from 'zustand'
import type { ColumnTotal } from '@/components/PlanDetail/DagColumnHeaderWithTotals'

/**
 * Live column totals for the plan table headers, keyed by anchor column id.
 *
 * Aggregates change on every DAG recompute. Passing them through
 * headerComponentParams forced a full columnDefs rebuild (every column) per
 * SSE aggregate event; headers subscribe here instead so only their own text
 * re-renders.
 */
interface ColumnTotalsState {
  totals: Record<string, ColumnTotal[]>
  setTotals: (totals: Record<string, ColumnTotal[]>) => void
}

export const useColumnTotalsStore = create<ColumnTotalsState>(set => ({
  totals: {},
  setTotals: totals => set({ totals }),
}))
